define(function (require) {
	return {
		versionRange: function (loVersion, hiVersion) {
			//versionRange( '8.5.0.1711' , '8.6')   return boolean
			//versionRange( '8.6.0.1712' )   return boolean
			//Version >= 8.5.0.1711 and Version < 8.6.0.0
			//OR
			//Version >= 8.6.0.1712 and up
			if (!_.isUndefined(hiVersion)) {
				if (this.versionCompare(hiVersion) >= 0) {
					return false;
				}
			}
			if (this.versionCompare(loVersion) >= 0) {
				return true;
			}
			return false; // not within range by default
		},
		versionCompare: function (versionToCompare) {
			//usage ViewManager.versionCompare('8.4.0.0'), return 1 if curr version is larger than 8.4
			var versionSplit = versionToCompare.split('.');
			var versionUnitCount = 4;
			var needToAppend = versionUnitCount - versionSplit.length;
			if (needToAppend < 0 || needToAppend > 4) { needToAppend = versionUnitCount; }
			for (i = 0; i < needToAppend; i++) {
				versionSplit[versionUnitCount - needToAppend + i] = 0;
			}

			var currentVersionArray = App.currentIPSVersionArray;

			for (var i = 0; i < 4; i++) {
				//current vresion is greater than the version being compared
				if (parseInt(currentVersionArray[i]) > parseInt(versionSplit[i])) {
					return 1;
				}
				if (parseInt(currentVersionArray[i]) < parseInt(versionSplit[i])) {
					return -1;
				}
			}
			return 0;
		}
	}
});